import { hexToRgbA, getLightenColor, getDarkenColor } from './'
export default (type, colors) => {
  const styles = {
    default: {
      'c-article__details': {
        customCSS: `
          .c-article__details .c-article__share-link {
            color: ${colors.secondary_dark};
          }
          .c-article__details .c-article__share-link:hover,
          .c-article__details .c-article__share-link:focus,
          .c-article__details .c-article__share-link:active {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
        `
      },
      'c-article__resource-nav': {
        background: hexToRgbA(getDarkenColor(colors.primary, 0.07), 0.5)
      },
      'c-article__media-object': {
        customCSS: `
          [data-article-style=grid] .c-article__media-extra-images .c-article__media-object,
          [data-article-style=map] .c-article__media-extra-images .c-article__media-object {
            border-color: ${colors.tertiary};
          }
        `
      },
      'c-article__excerpt': {
        customCSS: `
          [data-article-style=fluid] .c-article__excerpt:after,
          .p-scrapbook[data-article-style=details] .c-article__excerpt:after {
            background: linear-gradient(to bottom, ${hexToRgbA(colors.light,0)} 0%,${hexToRgbA(colors.light,1)} 90%);
          }
          [data-article-style=details] .c-article__excerpt:after {
            background: linear-gradient(to bottom, ${hexToRgbA(getDarkenColor(colors.light, 0.026),0)} 0%, ${hexToRgbA(getDarkenColor(colors.light, 0.026),1)} 90%);
          }
        `
      },
      'c-article__media-layout-holder': {
        customCSS: `
          [data-article-style=grid] .c-article__media-layout-holder:after, 
          [data-article-style=fluid] .c-article__media-layout-holder:after, 
          [data-article-style=map] .c-article__media-layout-holder:after {
            color: ${colors.primary};
          }
        `
      },
      'c-article': {
        customCSS: `
          [data-article-style=fluid] {
            background: linear-gradient(to bottom, ${hexToRgbA(colors.light,0)} 0%, ${hexToRgbA(colors.light,1)} 90%);
          }

          [data-article-style=list].c-article:hover,
          [data-article-style=list].c-article:active,
          [data-article-style=list].c-article:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }
          [data-article-style=list].c-article .item-list__action:hover,
          [data-article-style=list].c-article .item-list__action:active,
          [data-article-style=list].c-article .item-list__action:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }

          [data-article-style="article"] .c-article__footer:before {
            border-top: 2px solid ${getLightenColor(colors.secondary, 0.21)};
          }

          [data-article-style="article"] .c-article__content:after {
            border-color: ${getLightenColor(colors.secondary, 0.21)} transparent transparent transparent;
          }

          [data-article-style="item"] .c-article__details, [data-article-style="article"] .c-article__details {
            border-bottom: 1px solid ${getLightenColor(colors.secondary, 0.21)};
          }
        `
      },
      'c-article__subtitle': {
        color: colors.primary
      }
    },
    type1: {
      'c-article': {
        customCSS: `
          .search-results__listings[data-article-style=grid] .c-article, 
          .search-results__listings[data-article-style=fluid] .c-article {
            padding: 0 15px 15px!important;
          }
          .typography,
          dd,
          .c-article__content,
          .c-article__title,
          .c-article__title a {
            color: ${colors.dark};
          }
          .typography:hover,
          dd:hover,
          .c-article__content:hover,
          .c-article__title:hover,
          .c-article__title a:hover {
            background-image: none;
          }

          [data-article-style=article] .c-article__header {
            padding-bottom: 2em;
          }

          [data-article-style=fluid] {
            background: linear-gradient(to bottom, ${hexToRgbA(colors.light,0)} 0%, ${hexToRgbA(colors.light,1)} 90%);
          }

          [data-article-style=list].c-article:hover,
          [data-article-style=list].c-article:active,
          [data-article-style=list].c-article:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }
          [data-article-style=list].c-article .item-list__action:hover,
          [data-article-style=list].c-article .item-list__action:active,
          [data-article-style=list].c-article .item-list__action:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }

          [data-article-style="item"] .c-article__related-items {
            border-color: ${getDarkenColor(colors.light, 0.05)};
          }

          [data-article-style="item"] .c-aticle__main-info .c-article__details, 
          [data-article-style="article"] .c-aticle__main-info .c-article__details {
            border-bottom: 1px solid ${getDarkenColor(colors.light, 0.05)};
            margin-bottom: 2em;
          }
          
          [data-article-style="item"] .c-aticle__main-info .c-article__details dl, 
          [data-article-style="article"] .c-aticle__main-info .c-article__details dl {
            margin-bottom: 2em;
          }

          .c-aticle__main-info .c-article__details.actions {
            border: none;
          }

          @media screen and (min-width: 64em) {
            .state-filters-expanded .search-results .search-results__listings {
              margin-right: 370px !important;
            }
          }
        `
      },
      'c-aticle__main-info': {
        boxShadow: `0px 1px 11px ${hexToRgbA(colors.dark, 0.05)}`,
        padding: '3em'
      },
      'c-article-inner': {
        boxShadow:`0px 1px 11px ${hexToRgbA('#000', 0.07)}`,
      },
      'c-article__input': {
        height: 42,
        boxShadow: 'inset 0px 2px 9px rgba(0, 0, 0, 0.1)',
        fontSize: 18,
        textAlign: 'left',
        fontFamily: 'inherit',
      },
      'c-article__header': {
        color: colors.dark,
      },
      'c-article__intro': {
        fontSize: 18,
        color: colors.dark
      },
      'c-article__label': {
        textAlign: 'left',
        fontSize: 14
      },
      'c-article__content': {
        paddingLeft: 0,
        position: 'relative',
        customCSS: `
        .c-article__content.typography {
          margin-bottom: 40px;
        }
        .c-article__content.typography p {
          margin-bottom: 0;
        }
        `
      },
      'c-article__related-items': {
        paddingTop: '2em',
      },
      'c-article__resource-title': {
        color: colors.dark,
        margin: '0 0 7px 0',
        padding: 0,
        minHeight: 'auto',
        display: 'flex',
        flexDirection: 'row-reverse',
        flexWrap: 'wrap-reverse',
        justifyContent: 'flex-end'
      },
      'c-article__resource-title-name': {
        marginRight: '10px'
      },
      'c-article__resource_header': {
        display: 'flex',
        alineItems: 'center',
        marginBottom: '2em'
      },
      'c-article__title-wrap': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginLeft: '15px'
      },
      'c-article__recource-type': {
        color: getDarkenColor(colors.light, 0.4),
        textTransform: 'capitalize',
        fontSize: '14px'
      },
      'c-article__recource-type-name': {
        color: colors.primary,
        textTransform: 'capitalize',
        marginLeft: '5px',
        fontWeight: 'bold',
        fontSize: '16px'
      },
      'c-article__content__with-hexagon': {
        paddingTop: '40px',
      },
      'c-article__content__hexagon': {
        position: 'absolute',
        left: 0,
        top: '-50px',
      },
      'c-article__title': {
        display: 'flex',
        fontSize: '18px',
        minHeight: '62px',
        fontWeight: 'bold',
        alignItems: 'center',
        marginBottom: '25px',
        color: colors.primary,
        wordBreak: 'break-word',
        fontFamily: 'Helvetica-Neue-LT-Std'
      },
      'c-article__subtitle': {
        fontSize: '12px',
        fontWeight: 'bold',
        marginBottom: '10px',
        color: '#C4C4C4'
      },
      'c-article__media-flag': {
        display: 'none'
      },
      'c-article__excerpt': {
        fontSize: '16px',
        customCSS: `
          .c-article__excerpt a {
            background: none!important;
            color: ${colors.secondary};
          }
          [data-article-style=fluid] .c-article__excerpt:after,
          .p-scrapbook[data-article-style=details] .c-article__excerpt:after {
            background: linear-gradient(to bottom, ${hexToRgbA(colors.light,0)} 0%,${hexToRgbA(colors.light,1)} 90%);
          }
          [data-article-style=details] .c-article__excerpt:after {
            background: linear-gradient(to bottom, ${hexToRgbA(getDarkenColor(colors.light, 0.026),0)} 0%, ${hexToRgbA(getDarkenColor(colors.light, 0.026),1)} 90%);
          }
        `
      },
      'c-article__details': {
        customCSS: `
          .c-article__details h3 {
            font-size: 18px;
            font-weight: bold;
            color: ${hexToRgbA(colors.dark, 0.7)};
          }
          .c-article__details div:not(.list__def--inline) dd {
            font-size: 14px;
          }
          .c-article__details div:not(.list__def--inline) dd:last-of-type {
            margin-bottom: 20px;
          }
          .c-article__details div:not(.list__def--inline):last-of-type dd {
            margin-bottom: 0;
          }
          .c-article__details dt:first-of-type {
            margin-bottom: 10px;
            font-weight: bold;
            font-size: 12px;
            text-transform: none;
          }
          .c-article__details .button {
            padding: 1em 1.5em;
          }
          .c-article__details .c-article__location-map {
            margin-bottom: 25px;
          }
          .c-article__details .c-article__share-link {
            color: ${colors.secondary_dark};
          }
          .c-article__details .c-article__share-link:hover,
          .c-article__details .c-article__share-link:focus,
          .c-article__details .c-article__share-link:active {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
        `
      },
      'c-article__actions': {
        fontSize: '16px',
        textTransform: 'uppercase',
        customCSS: `
          .c-article__actions a, 
          .c-article__actions a:hover {
            background-image: none!important;
            color: ${colors.tertiary};
          }
          .c-article__actions .icon {
            margin-right: 10px;
            margin-bottom: 2px;
            font-size: 18px;
          }
        `
      },
      'c-article__content-wrap': {
        boxShadow: 'none',
        paddingTop: '20px'
      },
      'c-article__more-info': {
        background: 'transparent',
        color: colors.primary,
        margin: 0,
        padding: 0,
        backgroundImage: 'none!important',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontSize: '12px',
      },
      'c-article__defs': {
        customCSS: `
          .list__def {
            margin-bottom: 0;
          }
          .list__def--inline dd {
            margin-top: 16px;
          }
          .c-aticle__main-info .list__def--inline dd {
            margin-top: 0;
          }
          .list__def .badge__content {
            height: auto;
          }
          .list__def .taglist__addbtn {
            font-weight: bold;
          }
          .taglist__addbtn.badge--transparent {
            color: ${colors.secondary};
          }
          .taglist.list__def dd {
            margin: 8px 16px 8px 0;
          }
        `
      },
      'c-article-data__item--topOffset': {
        customCSS: `
          [data-article-style=item] .state-has-overlap + .c-tabs--pagey {
            margin-top: 20px;
          }

          @media screen and (max-width: 30em) {
            [data-article-style=item] .state-has-overlap + .c-tabs--pagey {
              margin-top: 0;
            }
          }
        `
      },
      'c-article__media-title': {
        fontWeight: 700,
        color: colors.primary,
        fontStyle: 'normal'
      },
      'content-medium': {
        customCSS: `
          footer.content-medium {
            margin-top: 10px;
          }
          .content-medium {
            float: left;
            width: 100%;
            margin-left: 0;
            color: ${colors.dark};
            padding-left: 2.83333rem!important;
            padding-right: 2.83333rem!important;
          }
          @media screen and (min-width: 64em) {
            .content-medium {
              width: 66.66667%;
              margin-left: 16.66667%;
            }
          }
        `
      },
      'c-article__pretitle': {
        customCSS: `
          [data-article-style=article] .c-article__pretitle:after {
            border-color: ${colors.secondary};
          }
        `
      },
      'c-article__buttons': {
        customCSS: `
          .share-button span,
          .download-button span {
            margin-right: 15px;
          }
        `
      },
      'c-article__download-button': {
        background: getDarkenColor(colors.light, 0.03),
        color: colors.primary,
        borderRadius: '6px',
        paddingRight: '10px',
        fontWeight: 'bold'
      },
      'c-article__share-button': {
        background: colors.primary,
        color: colors.light,
        borderRadius: '6px',
        paddingRight: '10px',
        fontWeight: 'bold'
      },
      'c-article__resource-nav': {
        background: hexToRgbA(getDarkenColor(colors.primary, 0.07), 0.5)
      },
      'c-article__media-object': {
        customCSS: `
          [data-article-style=grid] .c-article__media-extra-images .c-article__media-object,
          [data-article-style=map] .c-article__media-extra-images .c-article__media-object {
            border-color: ${colors.offgray_dark};
          }
        `
      },
      'c-article__media-layout-holder': {
        customCSS: `
          [data-article-style=grid] .c-article__media-layout-holder:after, 
          [data-article-style=fluid] .c-article__media-layout-holder:after, 
          [data-article-style=map] .c-article__media-layout-holder:after {
            color: ${colors.primary};
          }
        `
      },
      'actions-column': {
        position: 'absolute',
        right: '-47px',
        top: 0,
      },
      'actions-row': {
        border: '1px solid #ddd',
        padding: '10px 20px',
        marginTop: '-1px',
        display: 'flex',
        flexDirection: 'row-reverse',
      },
      'c-figure': {
        boxShadow: 'none',
        border: '1px solid #DBE3E8'
      },
      'c-figure__media': {
        margin: 5,
        display: 'block'
      },
      'c-figure__caption': {
        padding: 0,
        margin: '4px -1px 0'
      },
      'c-figure__attribution': {
        padding: '0 6px'
      },
      'c-article__media': {
        boxShadow: 'none',
        padding: 0,
        customCSS: `
          .c-image-upload__dropzone {
            border-color: #c4c4c4;
            color: ${colors.primary}
          }
        `
      },
      'save-article-final-buttons': {
        margin: '1rem 0.5rem'
      },
      'thanks-for-your-contribution': {
        textAlign: 'center',
        marginBottom: 30,
        marginTop: 50,
      },
      'thanks-for-your-contribution__p': {
        fontSize: 16,
        color: colors.dark
      },
      'thanks-for-your-contribution__list--inline': {
        textAlign: 'center'
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cArticle.js